import React from 'react';

export default class DpcBreadcrumb extends React.Component {
    getTitle = () => {
        if(typeof window !== "undefined")
            return window.location.pathname.split("/")[1] === 'it' ? 'Torna a ' : 'Back to ';
    }

    render() {
        return (
            <div className="col-xl-auto">
                <nav className="breadcrumb-container" aria-label="breadcrumb">
                    {(Array.isArray(this.props.items) && this.props.items.length > 0) &&
                    <ol className="breadcrumb">
                        {
                            this.props.items.map((item, i) => {
                                    return (
                                        <li className={`breadcrumb-item ${item.active ? "active" : ""}`} >
                                            {(item.slug && !item.active)
                                                ? <a href={item.slug}>{item.name}</a>
                                                : <>{item.name}</>
                                            }


                                            {i !== (this.props.items.length - 1) &&
                                            <span className="separator">&gt;</span>
                                            }
                                        </li>
                                    )
                                }
                            )
                        }
                    </ol>
                    }
                    {/*this.props.checkTorna &&
                    <div>
                        <a href={this.props.linkTorna} className="link-history-init">{this.getTitle()}<span
                                className="text-uppercase">{this.props.textTorna}</span></a>
                    </div>*/}

                </nav>
            </div>
        );
    }
}

